import type { MenuItem } from '@/models/menu';

export type ButtonVariant = 'text' | 'flat' | 'outlined' | 'plain' | 'tonal' | 'elevated';
export type ButtonDensity = 'default' | 'comfortable' | 'compact';
export type ButtonSize = 'x-small' | 'small' | 'default' | 'large' | 'x-large' | number;

export interface HorizontalNavigationProps {
  id?: string;
  // Button appearance
  btnVariant?: ButtonVariant;
  btnSize?: ButtonSize;
  btnRounded?: boolean | string | number;
  btnColor?: string;
  btnDensity?: ButtonDensity;
  btnClass?: string;
  showIcons?: boolean;
  dropdownIcon?: string;

  // Layout / wrapper
  wrapper?: 'toolbar' | 'none';
  color?: string; // toolbar color when wrapper === 'toolbar'
  navClass?: string; // extra class for the nav container
  gapClass?: string; // spacing class applied to each item container

  // Dropdown card / children item styles
  iconBgColor?: string;
  iconBgHoverColor?: string;
  cardMaxWidth?: number | string;
  cardClass?: string;
  cardContentClass?: string;
  listItemClass?: string;
  iconColor?: string;
  iconHoverColor?: string;
  iconClass?: string;
  iconHoverClass?: string;
}

export const defaults = {
  btnVariant: 'text' as ButtonVariant,
  btnSize: 'default' as ButtonSize,
  btnRounded: false as boolean | string | number,
  btnColor: '',
  btnDensity: 'comfortable' as ButtonDensity,
  btnClass: '',
  showIcons: true,
  dropdownIcon: 'mdi-chevron-down',

  wrapper: 'toolbar' as 'toolbar' | 'none',
  color: 'transparent',
  navClass: '',
  gapClass: 'mx-1',

  // Dropdown card / children item styles
  iconBgColor: 'transparent',
  iconBgHoverColor: 'transparent',
  cardMaxWidth: 300,
  cardClass: 'mx-auto rounded-lg',
  cardContentClass: 'pa-0',
  listItemClass: '',
  iconColor: 'text',
  iconHoverColor: 'text',
  iconClass: 'opacity-60',
  iconHoverClass: 'opacity-100',
};


